module.exports = __webpack_public_path__ + "img/icon_sp.9352c34d.png";